import React from "react";
import { ReactSVG } from "react-svg";
import { useEnvContext } from "@gw/env-context";
import { imgs } from "@gw/theming";
import { ContactSocialStyled } from "./ContactSocialStyled";
var ContactSocial = function (_a) {
    var twitter = _a.twitter, instagram = _a.instagram, facebook = _a.facebook, web = _a.web, className = _a.className;
    var imgsFolder = useEnvContext().imgsFolder;
    return (React.createElement(ContactSocialStyled, { className: className !== null && className !== void 0 ? className : "" },
        web && web !== "" && (React.createElement("a", { href: web, title: web, target: "_blank", rel: "noreferrer" },
            React.createElement(ReactSVG, { className: "contact-icon", src: imgsFolder + "/" + imgs.icons.iconWeb }))),
        twitter && twitter !== "" && (React.createElement("a", { href: twitter, title: twitter, target: "_blank", rel: "noreferrer" },
            React.createElement(ReactSVG, { src: imgsFolder + "/" + imgs.icons.iconTw }))),
        instagram && instagram !== "" && (React.createElement("a", { href: instagram, title: instagram, target: "_blank", rel: "noreferrer" },
            React.createElement(ReactSVG, { src: imgsFolder + "/" + imgs.icons.iconIg }))),
        facebook && facebook !== "" && (React.createElement("a", { href: facebook, title: facebook, target: "_blank", rel: "noreferrer" },
            React.createElement(ReactSVG, { src: imgsFolder + "/" + imgs.icons.iconFb })))));
};
export default ContactSocial;
//# sourceMappingURL=ContactSocial.js.map